(() => {
  const account = 'AW-1007619720';
  const target = `${account}/O0I2CI_lu78bEIidvOAD`;
  let configured = false;
  let observer;
  function configureCalls() {
    if (configured || typeof window.gtag !== 'function' || !Array.isArray(window.dataLayer)) return;
    const ready = window.dataLayer.some((entry) => entry && entry[0] === 'config' && entry[1] === account);
    if (!ready) return;
    configured = true;
    observer?.disconnect();
    window.gtag('config', target, {
      phone_conversion_number: '(800) 418-1954',
      send_page_view: false
    });
  }
  observer = new MutationObserver(configureCalls);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  configureCalls();
})();
